import React from "react"
import {IconBuildingSkyscraper} from "@tabler/icons-react"
import {useOrganization} from "@/utils/hooks/useOrganization"

export function OrgHeader() {
  const {orgName, orgId, loading: orgLoading} = useOrganization()

  return (
    <div className="mb-6 flex-shrink-0 overflow-hidden rounded-lg border border-black/5 bg-white shadow-sm">
      <div className="p-6">
        {/* Main title */}
        <div className="mb-6 border-b border-gray-100 pb-3">
          <h1 className="text-2xl font-bold">Organization Settings</h1>
          {/* <p className="mb-2 text-gray-500">
            Manage your organization's settings and filters
          </p> */}
        </div>

        {/* Organization details with icon beside name */}
        <div className="flex items-start">
          <div className="mr-3 flex-shrink-0 rounded-lg bg-blue-50 p-2 text-blue-500">
            <IconBuildingSkyscraper size={22} />
          </div>
          <div>
            <h2 className="text-lg font-medium">
              {orgLoading ? "Loading..." : orgName || "Unknown Organization"}
            </h2>
            <div className="mt-1 flex items-center text-gray-500">
              <p className="text-xs">Organization ID: {orgId || ""}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
